/** What the dashboard reads of the crowdsec module's metric (P5.2). */

export const DECISIONS_METRIC = 'crowdsec_active_decisions_count';

/** P5.2's four origin groups, in the words a person would use. */
export const ORIGIN_LABEL: Readonly<Record<string, string>> = {
  local: 'CrowdSec’s own scenarios',
  manual: 'Manual, including the dashboard',
  community: 'Community blocklists',
  other: 'Other',
};

export const ORIGINS = ['local', 'manual', 'community', 'other'] as const;
